// extracted by mini-css-extract-plugin
export default {"input":"AddCategory_input__c8ANV","placeHolderShimmer":"AddCategory_placeHolderShimmer__Vka3d"};